export default __webpack_public_path__ + "static/media/Emporium-white.54aaa191.png";